module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/3.fd5bf10f.jpg";